import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { usePageTitle } from "@Hooks/usePageTitle";
import { Box, Heading, Text, Flex, Icon } from "@chakra-ui/react";
import {
  IconFileSearch,
  IconHistory,
  IconChevronRight,
} from "@tabler/icons-react";

interface AcaoProps {
  icon: any;
  title: string;
  desc: string;
  onClick: () => void;
}

const Acao: FC<AcaoProps> = ({ icon, title, desc, onClick }) => (
  <Flex
    align="center"
    gap={4}
    px="18px"
    py="16px"
    borderRadius="10px"
    border="1px solid"
    borderColor="neutrals.stroke.soft-200"
    bg="neutrals.surface.surface-0"
    cursor="pointer"
    transition="all 0.15s"
    _hover={{ borderColor: "primary.light.base", bg: "primary.light.alpha-10" }}
    onClick={onClick}
  >
    <Flex
      align="center"
      justify="center"
      boxSize="40px"
      borderRadius="8px"
      bg="primary.light.alpha-10"
      color="primary.light.base"
      flexShrink={0}
    >
      <Icon as={icon} boxSize="20px" />
    </Flex>
    <Box flex={1} minW={0}>
      <Text fontSize="15px" fontWeight="600" color="neutrals.text.strong-950" fontFamily="heading">
        {title}
      </Text>
      <Text fontSize="13px" color="neutrals.text.sub-600" fontFamily="body">
        {desc}
      </Text>
    </Box>
    <Icon as={IconChevronRight} boxSize="18px" color="neutrals.icon.soft-400" />
  </Flex>
);

export const InicioPage: FC = () => {
  usePageTitle("Mapa de Rota");
  const navigate = useNavigate();

  return (
    <Box maxW="720px">
      <Heading fontSize="24px" fontFamily="heading" color="neutrals.text.strong-950">
        Mapa de Rota
      </Heading>
      <Text mt="6px" fontSize="sm" color="neutrals.text.sub-600" fontFamily="body">
        Analise abastecimentos, encontre economia na rede credenciada e gere o estudo pronto para o cliente.
      </Text>

      <Flex direction="column" gap="12px" mt="24px">
        <Acao
          icon={IconFileSearch}
          title="Nova análise"
          desc="Avaliar um cliente da base ou analisar um novo prospect."
          onClick={() => navigate("/nova-consulta")}
        />
        <Acao
          icon={IconHistory}
          title="Histórico"
          desc="Consultar os estudos já gerados pelo time."
          onClick={() => navigate("/historico")}
        />
      </Flex>
    </Box>
  );
};
